import React, { useId } from 'react';
import { Button } from '@noths/polaris-design-system-core-components';

import type { TrustBannerProps } from './types';
import * as styles from './TrustBanner.styles';

export const TrustBanner = ({ cards, cta, headline, introText, logo }: TrustBannerProps) => {
  const headlineId = useId();

  return (
    <section aria-labelledby={headlineId} css={styles.section}>
      {introText && <p css={styles.introText}>{introText}</p>}
      {logo && <img alt={logo.alt} css={styles.logo} src={logo.src} />}
      <h2 css={styles.headline} id={headlineId}>
        {headline}
      </h2>
      <ul css={styles.cardList}>
        {cards.map((card) => (
          <li css={styles.card} key={card.text}>
            <img alt={card.image.alt} css={styles.cardImage} src={card.image.src} />
            <p css={styles.cardText}>{card.text}</p>
          </li>
        ))}
      </ul>
      {cta && (
        <Button href={cta.href} secondary>
          {cta.text}
        </Button>
      )}
    </section>
  );
};
